export type CustomerAnalysisSortKey =
  | 'tracked_item_quantity'
  | 'tracked_item_avg_monthly_3m'
  | 'tracked_item_avg_monthly_6m'
  | 'tracked_item_growth_pct'
  | 'days_until_next_order'
  | 'aged_debt_amount'
  | 'unpaid_amount'
  | 'customer_name';

export interface CustomerAnalysisSortableRow {
  customer_name: string;
  tracked_item_quantity: number;
  tracked_item_avg_monthly_3m: number;
  tracked_item_avg_monthly_6m: number;
  tracked_item_growth_pct: number | null;
  days_until_next_order?: number | null;
  aged_debt_amount: number;
  unpaid_amount: number;
}

export function matchesNumericRange(
  value: number | null | undefined,
  minRaw: string,
  maxRaw: string,
): boolean {
  const parseFilterNumber = (raw: string): number | null => {
    if (!raw.trim()) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const min = parseFilterNumber(minRaw);
  const max = parseFilterNumber(maxRaw);
  const current = value ?? 0;
  if (min != null && current < min) return false;
  if (max != null && current > max) return false;
  return true;
}

export function sortCustomerAnalysisRows<T extends CustomerAnalysisSortableRow>(
  rows: T[],
  sortKey: CustomerAnalysisSortKey,
  sortDir: 'asc' | 'desc',
): T[] {
  return [...rows].sort((a, b) => {
    if (sortKey === 'days_until_next_order') {
      const av = a.days_until_next_order;
      const bv = b.days_until_next_order;
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      return sortDir === 'asc' ? av - bv : bv - av;
    }

    const av = a[sortKey] ?? 0;
    const bv = b[sortKey] ?? 0;
    if (typeof av === 'string' && typeof bv === 'string') {
      return sortDir === 'asc' ? av.localeCompare(bv) : bv.localeCompare(av);
    }
    return sortDir === 'asc' ? Number(av) - Number(bv) : Number(bv) - Number(av);
  });
}
